import { SearchField } from '@/components/Form';
import { AnalyzeTab } from '@/features/analyze/components/AnalyzeTab';
import { SearchHelpIconModal } from '@/features/analyze/components/SearchHelpIconModal';
import { TranslateSearchTextControls } from '@/features/analyze/components/TranslateSearchTextControls';
import { useSearchWithTranslation } from '../hooks/useSearchWithTranslation';

export const AnalyzeHeader = () => {
  const {
    errorMessage,
    translationInfo,
    searchWithTranslation,
    isTranslateSearchEnabled,
    setIsTranslateSearchEnabled,
    inputValue,
    setInputValue,
  } = useSearchWithTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <SearchField
          value={inputValue}
          onSubmit={searchWithTranslation}
          leftIcon={<SearchHelpIconModal />}
          onChange={setInputValue}
        />
        <TranslateSearchTextControls
          isEnabled={isTranslateSearchEnabled}
          onToggle={setIsTranslateSearchEnabled}
          translationInfo={translationInfo}
        />
        {errorMessage && (
          <div className="text-sm text-red-600">{errorMessage}</div>
        )}
      </div>

      <AnalyzeTab />
    </div>
  );
};
